import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import AppProvider from "./contextApi/Auth";
import theme from "./assets/theme/theme.js";

import "./assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/argon-dashboard-react.scss";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PurchaseProvider from "./contextApi/Purchase";

import FullViewLoader from "./components/Loader/fullViewLoader";

function App() {
  const Router = lazy(() => import("./router"));
 
  return (
    <AppProvider>
      <ToastContainer
        style={{
          zIndex: 9999999999999999999999999,
        }}
      />
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <PurchaseProvider>
            <Suspense fallback={<FullViewLoader />}>
              <Router />
            </Suspense>
          </PurchaseProvider>
        </BrowserRouter>
      </ThemeProvider>
    </AppProvider>
  );
}

export default App;
